import React, { Component } from 'react';
import { Card } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

class ProceduresTempletes extends Component {

    render() {
        return (
            <Card>
                <div className="form" style={{ flex: 1, flexDirection: 'column', display: 'flex' }}>

                    <div className="card__title">
                        <h5 className="bold-text">ECO</h5>
                    </div>
                    <div>
                        <div style={{ margin: 10 }}>
                            <CKEditor
                                style={{ width: '100%', height: '200px' }}
                                editor={ClassicEditor}
                                data={this.props.data.ECO.conclusions != null ? this.props.data.ECO.conclusions : null}
                                onChange={(event, editor) => {
                                    const data = editor.getData();
                                    this.props.handlerMedicalProcedures("ECO", "conclusions", data);
                                }}
                            />
                        </div>
                    </div>
                    <div className="card__title">
                        <h5 className="bold-text">Estres</h5>
                    </div>
                    <div style={{ flexDirection: 'row', display: 'flex' }}>
                    </div>
                        <div>
                            <div style={{ margin: 10 }}>
                                <CKEditor
                                    style={{ width: '100%', height: '200px' }}
                                    editor={ClassicEditor}
                                    data={this.props.data.Stress.conclusions != null ? this.props.data.Stress.conclusions : null}
                                    onChange={(event, editor) => {
                                        const data = editor.getData();
                                        this.props.handlerMedicalProcedures("Stress", "conclusions", data);
                                    }}
                                />
                            </div>
                        </div>
                    <div className="card__title">
                        <h5 className="bold-text">EKG</h5>
                    </div>
                    <div>
                        <div style={{ margin: 10 }}>
                            <CKEditor
                                style={{ width: '100%', height: '200px' }}
                                editor={ClassicEditor}
                                data={this.props.data.EKG.conclusions != null ? this.props.data.EKG.conclusions : null}
                                onChange={(event, editor) => {
                                    const data = editor.getData();
                                    this.props.handlerMedicalProcedures("EKG", "conclusions", data);
                                }}
                            />
                        </div>
                    </div>

                    <div className="card__title">
                        <h5 className="bold-text">Mapa</h5>
                    </div>
                    <div>
                        <div style={{ margin: 10 }}>
                            <CKEditor
                                style={{ width: '100%', height: '200px' }}
                                editor={ClassicEditor}
                                data={this.props.data.Map.conclusion != null ? this.props.data.Map.conclusion : null}
                                onChange={(event, editor) => {
                                    const data = editor.getData();
                                    this.props.handlerMedicalProcedures("Map", "conclusion", data);
                                }}
                            />
                        </div>
                    </div>

                    <div className="card__title">
                        <h5 className="bold-text">Holter</h5>
                    </div>
                    <div>
                        <div style={{ margin: 10 }}>
                            <CKEditor
                                style={{ width: '100%', height: '200px' }}
                                editor={ClassicEditor}
                                data={this.props.data.Holter.conclusion != null ? this.props.data.Holter.conclusion : null}
                                onChange={(event, editor) => {
                                    const data = editor.getData();
                                    this.props.handlerMedicalProcedures("Holter", "conclusion", data);
                                }}
                            />
                        </div>
                    </div>

                    <div className="card__title">
                        <h5 className="bold-text">Test</h5>
                    </div>
                    <div>
                        <div style={{ margin: 10 }}>
                            <CKEditor
                                style={{ width: '100%', height: '200px' }}
                                editor={ClassicEditor}
                                data={this.props.data.Test.conclusions != null ? this.props.data.Test.conclusions : null}
                                onChange={(event, editor) => {
                                    const data = editor.getData();
                                    this.props.handlerMedicalProcedures("Test", "conclusions", data);
                                }}
                            />
                        </div>
                    </div>
                </div>
            </Card>
        );
    }
}

export default reduxForm({
    form: 'templetes_procedures_form', // a unique identifier for this form
})(withTranslation('common')(ProceduresTempletes));